import { gatewayFetch } from "src/managers/GatewayProxy";
import { EjendomDataFormated, EjendomEjerskab, EjendomHandel, ViamapEjendomStatsData } from "./DLLTypes";

export class dllCollector {

   static async EjendomDataMatrikel(ejerlavsKode: string | number, matrikelNummer: string): Promise<any> {
      const body = {
         "Matrikler": [
            {
               "ejerlavskode": ejerlavsKode + "", //string
               "ejerlavsnavn": "",
               "matrikelnummer": matrikelNummer
            }
         ],
         "SagsNr": "ASM_1"
      };
      return fetchDLL("getEjendomDataFormated", body);
   }

   static async EjendomData(BFENummer: string): Promise<EjendomDataFormated> {
      const body = {
         "SagsNr": "ASM_1",
         "BFEnr": BFENummer,
         "Matrikler": []
      }
      return fetchDLL("getEjendomDataFormated?BFEnr=" + BFENummer, body);
   }

   static async EjendomHandel(BFENummer: string): Promise<EjendomHandel> {
      const body = {
         "BFEnr": BFENummer
      }
      return fetchDLL("getHandelsOplysning", body);
   }

   static async EjendomEjerskab(BFENummer: number | string): Promise<EjendomEjerskab> {
      const body = {
         "BFEnr": BFENummer
      }
      return fetchDLL("getejerskab", body, "GET");
   }

   static async OmrådeStatistikEjendomme(kommuneNr: string, postNr: string): Promise<ViamapEjendomStatsData> {
      const body = {
         "kommuneNr": kommuneNr,
         "postNr": postNr,
         "kategori": "1"
      };
      return fetchDLL("getEjendomStats", body);
   }


}

function fetchDLL(endpoint: string, body: any, type: "POST" | "GET" = "POST"): Promise<any> {
   return gatewayFetch("dll", endpoint, type === "GET" ? { method: "GET", query: body } : { body }).then((response) => {
      if (!response.ok) {
         throw new Error("Network response was not ok");
      }
      return response.json();
   });
}



